import React from 'react'
import { vn } from 'vend-number'
import { CashDiscountingModal } from '../../../payments/cash-discounting-modal/CashDiscountingModal'
import { useAppSelector } from '../../../../state/hooks'
import { selectOutstandingBalance } from '../../../../state/slices/currentSale/currentSaleSlice'
import { useSaleManager } from '../../../../ng-compat/hooks'
import { CashDiscountingPaymentOption, SalePayment } from './types'

interface Props {
  onClose: () => void
  onSuccess: (result: SalePayment) => void
  paymentOptions: CashDiscountingPaymentOption
}

export const CashDiscounting = ({
  paymentOptions,
  onClose,
  onSuccess,
}: Props) => {
  const balance = useAppSelector(selectOutstandingBalance)
  const saleManager = useSaleManager()
  const handlePayment = (result: Promise<number>) => {
    result
      .then(amount => {
        onSuccess({
          paymentType: paymentOptions.paymentType,
          paymentAmount: amount,
        })
      })
      // In original component, rejected promises just means the modal is closed
      .catch(() => {
        onClose()
      })
  }

  return (
    <CashDiscountingModal
      close={handlePayment}
      amountTendered={vn(paymentOptions.amountTendered).toNumber()}
      balance={balance}
      cashDiscountedBalance={vn(
        saleManager.getCashDiscountedOutstandingBalance()
      ).toNumber()}
    />
  )
}
